import React from 'react';
import { Zap, Lightbulb, Thermometer, Users } from 'lucide-react';

// Overview View Mode - used for switching between dashboard views
export type OverviewViewMode = 'energy' | 'adaptive-lighting' | 'hvac-control' | 'occupancy-analytics' | 'blind-curtain';

interface ViewSwitcherProps {
  value: OverviewViewMode;
  onChange: (mode: OverviewViewMode) => void;
  className?: string;
}

const viewOptions: { value: OverviewViewMode; label: string; icon: React.ReactNode }[] = [
  { value: 'energy', label: 'Energy', icon: <Zap className="w-4 h-4" /> },
  { value: 'adaptive-lighting', label: 'Lighting', icon: <Lightbulb className="w-4 h-4" /> },
  { value: 'hvac-control', label: 'HVAC', icon: <Thermometer className="w-4 h-4" /> },
  { value: 'occupancy-analytics', label: 'Occupancy', icon: <Users className="w-4 h-4" /> },
];

const ViewSwitcher: React.FC<ViewSwitcherProps> = ({ value, onChange, className = '' }) => {
  return (
    <div className={`flex items-center bg-slate-800/50 rounded-lg p-0.5 ${className}`}>
      {viewOptions.map((option) => {
        const isActive = value === option.value;
        return (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`
              flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200
              ${isActive 
                ? 'bg-slate-700/70 text-cyan-400 shadow-sm' 
                : 'text-slate-400 hover:text-slate-200'
              }
            `}
            title={option.label}
          >
            {option.icon}
            <span className="hidden sm:inline">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ViewSwitcher;
